// @flow

import { type ConfirmedIncomingPayment, type CanceledIncomingPayment, type PendingIncomingPayment } from './types';

export function getWaitBeforeRedirect(incomingPayment: ConfirmedIncomingPayment|CanceledIncomingPayment|PendingIncomingPayment): ?number {
  if (incomingPayment.v2 && incomingPayment.v2.redirect)
    return incomingPayment.v2.redirect.wait_before_redirect;

  return incomingPayment['wait_before_redirect'];
}
